import { Box, Text, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

const Certification = () => {
  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row'
      }}
      justifyContent="space-between"
      gap={5}
      pb={{
        base: '80px',
        lg: 10
      }}
      position="relative"
    >
      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0'
        }}
      >
        <AspectRatio ratio={1247 / 1133} w="100%">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/banner-left-1734075592405.png"
            alt="bg left"
            fill
          />
        </AspectRatio>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
        mt={{
          base: 5,
          lg: 0
        }}
      >
        <Flex
          w="100%"
          h="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
          flexDirection={'column'}
          justifyContent={{
            base: 'center',
            lg: 'center'
          }}
          alignItems="center"
        >
          <Text
            textStyle="supplementCertificationTitle"
            color="#9cb259"
            w={{
              base: '90%',
              lg: '100%'
            }}
          >
            Crafting Wellness with more than 20 Years of Expertise.
          </Text>

          <Text
            textStyle="supplementCertificationDesc"
            color="#404040"
            mt={5}
            w={{
              base: '90%',
              lg: '100%'
            }}
          >
            We have partnered with one of Japan’s top pharmaceutical
            manufacturers, renowned for their expertise in active pharmaceutical
            ingredients (API) and cutting-edge laboratory research.{' '}
            <span className="font-bold">
              We place great emphasis on quality management, ensuring that every
              product is crafted in a safe and trustworthy environment.
            </span>
          </Text>
        </Flex>
      </Box>

      <Box
        position="absolute"
        bottom={0}
        right={0}
        w={{
          base: '50%',
          lg: '300px',
          xl: '600px'
        }}
      >
        <AspectRatio ratio={840 / 139} w="100%">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bottom-certification-1734075592407.png"
            alt="bottom shape certification"
            fill
          />
        </AspectRatio>
      </Box>
    </Flex>
  )
}

export default Certification
